import React from "react";
import { useTranslation } from "@helpers/translate";
import CrossIcon from "@assets/icons/CrossIcon";

/**
 * Close (×) button of the trade modals, styled by the modal's own class.
 *
 * @param {object} props
 * @param {string} props.className
 * @param {() => void} props.onClick
 * @param {number} [props.iconSize] CrossIcon's own default when not set
 */
export const ModalCloseButton = ({ className, onClick, iconSize }) => {
  const { __ } = useTranslation();

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-label={__("futures.trade_modals.close")}
    >
      <CrossIcon size={iconSize} />
    </button>
  );
};
